import axios from 'axios'

import {
  defaultErrorHandler,
  dPoPRequestInterceptor,
  dPoPResponseInterceptor,
} from './interceptors'

export const branchHttp = axios.create({
  baseURL: import.meta.env.VITE_BRANCH_API_URL,
  timeout: 3600000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

branchHttp.interceptors.request.use(dPoPRequestInterceptor, defaultErrorHandler)
branchHttp.interceptors.response.use(
  dPoPResponseInterceptor,
  defaultErrorHandler
)
